// TODO: maybe replaced by
// https://github.com/Calvein/empty-module
// https://github.com/crimx/empty-module-loader
define(function () {});



// WEBPACK FOOTER //
// ./src/empty.js